import React from 'react';
import { Table } from 'reactstrap';
import { useHistory } from 'react-router-dom';

const AccountsListTable = ({ accounts }) => {
  const history = useHistory();
  if (!accounts || accounts.length === 0) {
    return <div style={{ textAlign: 'center' }}>Nenhuma conta encontrada.</div>;
  }
  return (
    <div>
      <Table
        bordered
        hover
        responsive
        size="sm"
        className="text-center align-middle"
      >
        <thead>
          <tr>
            <th className="text-center align-middle" style={{ width: 50 }}>
              #
            </th>
            <th className="text-center align-middle">Nome</th>
          </tr>
        </thead>
        <tbody>
          {accounts.map((acc, idx) => (
            <tr key={acc.id}>
              <td className="text-center align-middle">{idx + 1}</td>
              <td
                className="text-center align-middle"
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() =>
                  history.push(
                    `/admin/crm/accounts/${acc.recordTypeId || ''}/${acc.id}`
                  )
                }
                title="Clique para editar"
              >
                {acc.name}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default AccountsListTable;
